// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"ae33e0de","225":"ad74b3cb","380":"9fbb7db6","416":"318410d4","462":"75e96224","637":"e5c795de","681":"746470b1","787":"fa9cb370","791":"3cacb9ab","820":"8a708729","896":"fa8bbc64","938":"7f4580b9"}[chunkId] + ".chunk.js";
};